<template>
  <div class="widget digital-presence title-margin">
    <h3 class="widget-title">
      Detalle de tu presencia digital en {{ $route.params.productName }}
    </h3>
    <card>
      <h4 class="card-title">Resultados en {{ $route.params.productName }}</h4>
      <div class="results">
        <table class="table">
          <thead>
            <tr>
              <th v-if = "$route.params.businessUnitId != 3" scope="col">Clasificado</th>
              <th v-if = "$route.params.businessUnitId == 3" scope="col">Keywords</th>
              <th scope="col">Impresiones</th>
              <th v-if = "$route.params.businessUnitId != 3" scope="col">Clicks</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(digitalPresence, index) in digitalPresence"
              :key="index"
            >
              <td scope="row">
                <p class="clasificado">
                  {{ digitalPresence.ClassName.split(",")[0] }}
                </p>
              </td>
              <td scope="row">
                {{ Number(digitalPresence.impressions).toLocaleString() }}
              </td>
              <td v-if = "$route.params.businessUnitId != 3" scope="row">
                {{ Number(digitalPresence.clicks).toLocaleString() }}
              </td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th>Total</th>
              <th>{{ totalDigitalPresent.impreT1 }}</th>
              <th v-if = "$route.params.businessUnitId != 3" >{{ totalDigitalPresent.clickT1 }}</th>
            </tr>
          </thead>
        </table>
        <div class="chart">
          <apexchart
            type="pie"
            width="380"
            :options="digitalPresenceChartOptions"
            :series="digitalPresenceSeries"
          />
        </div>
      </div>
    </card>
    <div
      class="widget google-results title-margin"
      v-if="
        googleResults.length > 0
      "
    >
      <card>
        <h4 class="card-title">Resultados de búsqueda en Google</h4>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">URL</th>
              <th scope="col">Impresiones</th>
              <th scope="col">Clicks</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(googleResult, index) in groupByUrl(googleResults).sort((value1,value2)=> value2.impressions - value1.impressions)" :key="index">
              <td>
                <a :href="fullDomain+googleResult.url" target="_blank"
                  >{{
                    googleResult.url
                   }}</a
                >
              </td>
              <td scope="row">
                {{ Number(googleResult.impressions).toLocaleString() }}
              </td>
              <td scope="row">
                {{ Number(googleResult.clicks).toLocaleString() }}
              </td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th>Total </th>
              <th>{{ totalGoogle.googleImpressionsT1 }}</th>
              <th>{{ totalGoogle.googleClickT1 }}</th>
            </tr>
          </thead>
        </table>
      </card>
    </div>
  </div>
</template>
<script>
import randomcolor from "randomcolor";
import {YP_DOMAIN,AMCHAM_DOMAIN,SLOL_DOMAIN,PTG_DOMAIN,SPPR_DOMAIN} from "../../constants"

export default {
  name: "digital-presence",
  props: {
    digitalPresence: Array,
    totalDigitalPresent: Object,
    totalGoogle: Object,
    googleResults: Array
  },
  data() {
    return {
      googleResultsData: [],
      googleResultsFormated: [],
      domain: "",
      fullDomain: "",
      digitalPresenceLimit: [],
      totalClicksAndImpressions: {},
      digitalPresenceChartBaseOptions: {
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      },
      YP_DOMAIN,
      AMCHAM_DOMAIN,
      SLOL_DOMAIN,
      PTG_DOMAIN
    };
  },
  computed: {
    digitalPresenceChartOptions() {
      return this.getChartOptions();
    },
    digitalPresenceSeries() {
      return (this.digitalPresence || []).map(element =>
        parseInt(element.impressions)
      );
    }
  },
  methods: {
    getPieColor() {
      return (this.digitalPresence || []).map(() =>
        randomcolor({
          hue: "blue"
        })
      );
    },
    convertToPaths(list=[],domain=""){
      const newList = []
      list.map(values => {
        const paths = values.url.split(domain)[1];
        newList.push({...values,url:paths}  ) 
      });      
      return newList;
    },
    groupByUrl(list = []){
      const domain = this.getDomain(list)
      let listFormated = list.map(values => {
        const path = values.url.split(domain)[1];
        
        return {...values,url:path}
      });
      let uniquePaths = new Set(listFormated.map(value => value.url)); 
      
      const resultsGrouped = [];

    
      uniquePaths.forEach((value) => {

        const sameUrlresults = listFormated.filter(results => results.url == value);
        const summarizeresults = sameUrlresults.reduce((acc,cur)=> {
          return {
            ...cur,
            impressions: cur.impressions + acc.impressions,
            clicks: cur.clicks + acc.clicks
          }
        })
        resultsGrouped.push(summarizeresults);
      })

      return resultsGrouped
    },
    getDomain(list = []){
      return list[0].url.includes(YP_DOMAIN) ? YP_DOMAIN : 
             list[0].url.includes(SLOL_DOMAIN) ? SLOL_DOMAIN : 
             list[0].url.includes(PTG_DOMAIN) ? PTG_DOMAIN : 
             list[0].url.includes(SPPR_DOMAIN) ? SPPR_DOMAIN : 
             list[0].url.includes(AMCHAM_DOMAIN) ? AMCHAM_DOMAIN : ""
    },
    getFullDomain(list=[],domain=""){
      const protocol = list[0].url.split(domain)[0];

      return domain==YP_DOMAIN ? protocol+YP_DOMAIN : protocol+domain;
      
    },
    getChartOptions() {
      let classNames = (this.digitalPresence || []).map(
        element => element.ClassName
      );
      let colors = [
        "#0A286E",
        "#0E3593",
        "#1248C9",
        "#3772FF",
        "#08ACFF",
        "#93ABE6",
        "#BECDF0"
      ];
      // this.getPieColor();
      let digitalPresenceChartOptions = {
        ...this.digitalPresenceChartBaseOptions,
        labels: classNames,
        colors
      };
      return digitalPresenceChartOptions;
    }
  },
  created: function() {
    const haveUrl = this.googleResults.length > 0
    this.digitalPresenceLimit = this.digitalPresence.slice(0, 5);
    const domain = haveUrl ? this.getDomain(this.googleResults) : "";
    this.fullDomain = haveUrl ? this.getFullDomain(this.googleResults,domain) : "";
    
    // this.googleResults = this.googleResults.sort((value1,value2)=> value2.impressions - value1.impressions);
    // this.googleResults = this.groupByUrl(googleResultsFormated,domain).sort((value1,value2)=> value2.impressions - value1.impressions);
  },
};
</script>
<style lang="scss" scoped>
.clasificado {
}

.table th {
  min-width: 100px;
}
@include respond-above(lg) {
  .results {
    display: grid;
    grid-template-columns: 1fr 400px;
    grid-gap: 20px;
    justify-content: center;
  }
}

@include respond-above(sm) {
  .table {
    display: table;
    white-space: normal;
  }
}
</style>
